import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  Navigate,
} from "react-router-dom";
import AboutPage from "./pages/app/about/About";
import Signin from "./pages/auth/Signin";
import Signup from "./pages/auth/Signup";
import Verify from "./pages/auth/Verify";
import Navbar from "./components/navbar/Navbar";
import Error from "./components/errors-messages/Error";
import PageNotFound from "./components/errors/PageNotFound";
import { login } from "./apis/authApi";
import React from "react";
import { useState, useEffect } from "react";
import "./App.css";
import "./styles.css";
import ResourcePages from "./pages/app/resourcePages/ResourcePages";
import UserContext from "./context/UserContext";
import { getUserData } from "./apis/userApi";
import Profile from "./pages/app/user/Profile";
import ResetPassword from "./pages/app/user/ResetPassword";
import Footer from "./components/footer/Footer";
import { getResources } from "./apis/resourcesApi";
function App() {
  const [state, setState] = useState({
    isAuth: false,
    token: null,
    authLoading: true,
    error: null,
    message: null,
    userData: {},
    contacts: [],
    errorMessage: null,
  });
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchContacts();
    const token = localStorage.getItem("token");
    const expiryDate = localStorage.getItem("expiryDate");

    if (!token || !expiryDate) {
      return setState((prevState) => {
        return {
          ...prevState,

          authLoading: false,
        };
      });
    }
    if (new Date(expiryDate) <= new Date()) {
      logoutHandler();
      return setState((prevState) => {
        return {
          ...prevState,

          authLoading: false,
        };
      });
    }
    const remainingMilliseconds =
      new Date(expiryDate).getTime() - new Date().getTime();
    fetchData(token);
    setState((prevState) => {
      return {
        ...prevState,
        isAuth: true,
        token: token,
        authLoading: false,
      };
    });
    setAutoLogout(remainingMilliseconds);
  }, []);

  const fetchUserDataHandler = async (token) => {
    const { data, error } = await getUserData(token);

    if (error) {
      return setState({
        isAuth: false,
        token: null,
        authLoading: true,
        message: null,
        userData: {},

        error: "Something went wrong, please try again",
      });
    }
    setState((prevState) => {
      return {
        ...prevState,

        userData: data.userData,
      };
    });
  };
  const fetchData = async (token) => {
    await fetchUserDataHandler(token);
  };
  const fetchContactsHandler = async () => {
    const { data, error } = await getResources("contacts");
    if (error) {
      setLoading(false);

      return setState((prevState) => {
        return {
          ...prevState,
          contacts: "Couldn't load contacts",
        };
      });
    }
    setState((prevState) => {
      return {
        ...prevState,
        contacts: data.resources,
      };
    });
    setLoading(false);
  };
  const fetchContacts = async () => {
    await fetchContactsHandler();
  };
  const logoutHandler = () => {
    setState((prevState) => {
      return {
        ...prevState,
        isAuth: false,
        token: null,
        message: "you've been logged out",
        error: null,
        userData: {},
      };
    });
    localStorage.removeItem("token");
    localStorage.removeItem("expiryDate");
  };

  const loginHandler = async (event, authData) => {
    event.preventDefault();

    setState((prevState) => {
      return { ...prevState, authLoading: true };
    });
    const authForm = new FormData();
    authForm.append("email", authData.email);
    authForm.append("password", authData.password);
    const { data, error } = await login(authForm);

    if (error) {
      console.log(error);
      return setState((prevState) => {
        return {
          ...prevState,
          isAuth: false,
          token: null,
          error: data.message,
          authLoading: false,
          userData: {},
        };
      });
    }

    fetchData(data.token);

    setState((prevState) => {
      return {
        ...prevState,
        isAuth: true,
        token: data.token,
        authLoading: false,
      };
    });
    localStorage.setItem("token", data.token);

    const remainingMilliseconds = 3 * 24 * 60 * 60 * 1000;
    const expiryDate = new Date(new Date().getTime() + remainingMilliseconds);
    localStorage.setItem("expiryDate", expiryDate.toISOString());
    setAutoLogout(remainingMilliseconds);
    return { message: "succses" };
  };

  const setAutoLogout = (milliseconds) => {
    setTimeout(() => {
      logoutHandler();
    }, milliseconds);
  };

  const errorHandler = () => {
    setState((prevState) => {
      return { ...prevState, error: null, message: null };
    });
  };
  return (
    <UserContext.Provider
      value={{
        userData: state.userData,
        isLogged: state.isAuth,
        token: state.token,
        onLogout: logoutHandler,
      }}
    >
      {(state.error || state.message) && (
        <Error
          error={state.error || state.message}
          type={state.message}
          onHandle={errorHandler}
        />
      )}
      {!state.authLoading && !state.error ? (
        <Router>
          <Navbar onLogout={logoutHandler} />
          <Routes>
            <Route path="*" element={<PageNotFound />} />
            <Route path="/" element={<AboutPage></AboutPage>}></Route>
            <Route path="/resources" element={<ResourcePages />}></Route>
            <Route
              path="/join/signin"
              element={
                state.isAuth ? (
                  <Navigate to="/user/profile" />
                ) : (
                  <Signin
                    onSignin={loginHandler}
                    loading={state.authLoading}
                    errorMessage={state.error}
                  />
                )
              }
            ></Route>
            <Route
              path="/join/signup"
              element={
                state.isAuth ? (
                  <Navigate to="/user/profile" />
                ) : (
                  <Signup onSignup={loginHandler} loading={state.authLoading} />
                )
              }
            ></Route>
            <Route
              path="/join/verify"
              element={
                state.isAuth ? (
                  <Navigate to="/user/profile" />
                ) : (
                  <Verify onSignup={loginHandler} loading={state.authLoading} />
                )
              }
            ></Route>
            <Route
              path="/user/password_reset"
              element={
                state.isAuth ? (
                  <Navigate to="/user/profile" />
                ) : (
                  <ResetPassword
                    onSignup={loginHandler}
                    loading={state.authLoading}
                  />
                )
              }
            ></Route>
            <Route
              path="/user/profile"
              element={
                state.isAuth ? <Profile /> : <Navigate to="/join/signin" />
              }
            ></Route>
          </Routes>
          <Footer contacts={state.contacts} />
        </Router>
      ) : (
        <div className="h-full w-full flex justify-center">
          <span className="loading loading-ring loading-lg"></span>
        </div>
      )}
    </UserContext.Provider>
  );
}

export default App;
